import BasicConfigurationStep from './BasicConfigurationStep';

export default BasicConfigurationStep;
